module.exports = __webpack_public_path__ + "img/freespin2_multiplier9.8f5db71c.png";